import React from 'react'
import { BsCalendar3, BsCrosshair, BsTruck } from 'react-icons/bs'

interface ShippingDetailsProps {
  carrierName?: string
  trackingNumber?: string
  contactLink: string
  estimatedDeliveryRangeStart?: string | null
  estimatedDeliveryRangeEnd?: string | null
}

const formatDateBR = (dateStr: string) => {
  return new Date(dateStr + 'T00:00:00').toLocaleDateString('pt-BR')
}

const ShippingDetails: React.FC<ShippingDetailsProps> = ({
  carrierName,
  trackingNumber,
  contactLink,
  estimatedDeliveryRangeStart,
  estimatedDeliveryRangeEnd
}) => {
  return (
    <div className="flex flex-col gap-4">
      {carrierName && carrierName !== 'A definir' && (
        <div className="flex items-center gap-3 rounded-lg border border-gray-200 p-1">
          <BsTruck size={24} className="text-gray-600" />
          <p className="text-base text-gray-600">
            Transportadora: <span className="text-gray-900">{carrierName}</span>
          </p>
        </div>
      )}
      {trackingNumber && trackingNumber !== 'A definir' && (
        <div className="flex items-center gap-3 rounded-lg border border-gray-200 p-1">
          <BsCrosshair size={24} className="text-gray-600" />
          <p className="text-base text-gray-600">
            Código de rastreio: <span className="text-gray-900">{trackingNumber}</span>
          </p>
        </div>
      )}
      {estimatedDeliveryRangeStart && estimatedDeliveryRangeEnd && (
        <div className="flex items-center gap-3 rounded-lg border border-gray-200 p-1">
          <BsCalendar3 size={24} className="text-gray-600" />
          <p className="text-base text-gray-600">
            Entrega estimada:{' '}
            <span className="text-gray-900">
              {formatDateBR(estimatedDeliveryRangeStart)} a {formatDateBR(estimatedDeliveryRangeEnd)}
            </span>
          </p>
        </div>
      )}
      <p className="text-base text-gray-600">
        Ficou com alguma dúvida? entre em contato conosco{' '}
        <a
          href={contactLink}
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium text-primary-700 hover:underline">
          clicando aqui
        </a>
      </p>
    </div>
  )
}

export default ShippingDetails
